import React, { useContext } from 'react';
import { FirebaseContext } from '../contexts/FirebaseContext';

export default function withFirebase(WrappedComponent) {
  return (props) => {
    const firebase = useContext(FirebaseContext);
    return <WrappedComponent firebase={firebase} {...props} />;
  };
}
